import { useStrings } from "@1js/localization-components";
import { Tab, Text } from "@fluentui/react-components";
import React, { forwardRef } from "react";
import type { Appearance } from "../data";
import { YourPromptsLabel } from "./PromptTab.strings";
import { PromptTabs } from "./PromptTabs";
import { useRocksteadyStyles, useStyles } from "./Tab.styles";

export const BookmarkedTabTestId = "bookmarked-prompts-tab";

type BookmarkTabProps = {
  isSelected: boolean;
  appearance: Appearance;
  isRocksteadyUxEnabled?: boolean;
};

export const BookmarkTab = forwardRef<HTMLButtonElement, BookmarkTabProps>(
  (
    { isSelected, appearance, isRocksteadyUxEnabled = false, ...props },
    ref
  ) => {
    const localizations = useStrings({
      YourPromptsLabel,
    });

    const rocksteadyClasses = useRocksteadyStyles();
    const defaultClasses = useStyles(appearance)();
    const classes = isRocksteadyUxEnabled ? rocksteadyClasses : defaultClasses;

    return (
      <Tab
        aria-label={localizations.YourPromptsLabel()}
        value={PromptTabs.SavedPrompts}
        data-testid={BookmarkedTabTestId}
        className={isSelected ? classes.selected : classes.tab}
        ref={ref}
        {...props}
      >
        <Text className={isSelected ? classes.selectedText : classes.text}>
          {localizations.YourPromptsLabel()}
        </Text>
      </Tab>
    );
  }
);

BookmarkTab.displayName = "BookmarkTab";
